import React from 'react';

import MultiSelectColumnDropdown from 'data-frames/column-selector/MultiSelectColumnDropdown';
import {GetPipelineConfigSpecType, PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {ButtonSize} from 'ui-library/buttons/Button';

import {useStepConfigEditorContext} from '../StepConfigEditorContext';

interface MultiSelectColumnReferenceProps {
  config: Array<string | null>;
  onChangeConfig: (config: Array<string>) => void;
  configShape: GetPipelineConfigSpecType<'array'>;
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
}

export default function MultiSelectColumnReferenceEditor({
  config,
  onChangeConfig,
  configShape,
  dataTestAttrs,
  disabled,
}: MultiSelectColumnReferenceProps): JSX.Element {
  const {dataFrameSpec} = useStepConfigEditorContext();
  const selectedColumnSystemNames = config.filter((columnReference) => columnReference != null);
  return (
    <MultiSelectColumnDropdown
      dataFrameSpec={dataFrameSpec}
      dataTestAttrs={dataTestAttrs}
      onChange={onChangeConfig}
      selectedColumnSystemNames={selectedColumnSystemNames}
      validationOptions={
        (configShape.elementSpec as Extract<PipelineConfigJsonSpec, {kind: 'columnReference'}>)
          .validationOptions ?? undefined
      }
      buttonSize={ButtonSize.MEDIUM}
      noColumnSelectedText="Select columns"
      disabled={disabled}
    />
  );
}
